import {
  GET_REQUEST_LOG,
  GET_REQUEST_LOG_DETAIL,
  GET_REQUEST_LOG_DETAIL_FAIL,
  GET_REQUEST_LOG_DETAIL_SUCCESS,
  GET_REQUEST_LOG_FAIL,
  GET_REQUEST_LOG_SUCCESS,
  RESET_NOTES,
} from "src/constants/types";

export const requestReducers = (state = {}, actions) => {
  const { payload } = actions;
  switch (actions.type) {
    case GET_REQUEST_LOG:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_REQUEST_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        request_logs: payload,
      };
    case GET_REQUEST_LOG_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_REQUEST_LOG_DETAIL:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_REQUEST_LOG_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        request_log_detail: payload,
        notes: payload.notes,
      };
    case GET_REQUEST_LOG_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case RESET_NOTES:
      return {
        ...state,
        notes: null,
      };

    default:
      return state;
  }
};
